module.exports = __webpack_public_path__ + "img/dp-big--portfolio-04.269c71f6.jpg";